import { plural } from '@lingui/core/macro';
import { isPresent } from '@luminovo/commons';
import { formatDays } from '@luminovo/frontend-utils';

import { AvailabilityRenderOption } from '../TanStackTable/type';

/** Rounds up, so a lead time is never under-estimated: to half weeks below 10 weeks, then to whole weeks. */
function formatWeeks(days: number): string {
    if (days === 0) {
        return `0 ${plural(0, { one: 'week', other: 'weeks' })}`;
    }

    const exactWeeks = days / 7;

    const rounded = exactWeeks >= 10 ? Math.ceil(exactWeeks) : Math.ceil(exactWeeks * 2) / 2;

    return `${rounded} ${plural(rounded, { one: 'week', other: 'weeks' })}`;
}

export function formatAvailabilityDuration(
    days: number | null | undefined,
    renderOption: AvailabilityRenderOption = 'days',
): string {
    if (!isPresent(days) || !isFinite(days) || isNaN(days)) {
        return formatDays(days, { ifNotPresent: '-' });
    }

    return renderOption === 'weeks' ? formatWeeks(days) : formatDays(days);
}
